import React, { Component } from 'react';

class RenderErrorText extends React.Component {

  renderErrorList(list) {
    return(
      <ul className="m0 pl2">
        {list.map((textItem, index) => {
          if(textItem.message != undefined) {
            textItem = textItem.message;
          }
          return (
            <li key={"error-message-" + index}>{textItem}</li>
          );
        })}
      </ul>
    );
  }

  render() {
    let { text } = this.props;
    if(Array.isArray(text)) {
      return(this.renderErrorList(text));
    } else {
      if(text.base != undefined && Array.isArray(text.base)) {
        return(this.renderErrorList(text.base));
      } else {
        let errorMessage = text.message != undefined ? text.message : text;
        return (<div>{errorMessage}</div>);
      }

    }
  }
}

export default RenderErrorText;
